// extracted by mini-css-extract-plugin
module.exports = {"container":"dd","disabled":"ed","bgBlack":"fd","content":"gd","countdown":"hd","topCaption":"id","topHeading":"jd","heading":"kd","copy":"ld"};